function collecslid() {
if($(window).innerWidth() <= 767) { 
let numItems = $('.index3-collection .collection ul.grid li.grid__item').length;
let numItemw = $('.index3-collection .collection ul.grid li.grid__item').width();
let totwid = numItemw * numItems;
$('.index3-collection .collection ul.grid').css("width",totwid + "px");
$('.index3-collection .collection ul.grid li.grid__item').css("width",numItemw + "px");
 }
}

function expcollecslid() {
if($(window).innerWidth() <= 767) { 
let expnumItems = $('.index6-curated-flex .img-box-item').length;
let expnumItemw = $('.index6-curated-flex .img-box-item').width();
let exptotwid = expnumItemw * expnumItems;
$('.index6-curated-flex ').css("width",exptotwid + "px");
$('.index6-curated-flex .img-box-item').css("width",expnumItemw + "px");
 }
}

function reccollecslid() {
if($(window).innerWidth() <= 767) { 
  setTimeout(function() {
let recnumItems = $('.Recently-Viewed-sec .collection ul.grid li.grid__item').length;
let recnumItemw = $('.Recently-Viewed-sec .collection ul.grid li.grid__item').width();
let rectotwid = recnumItemw * recnumItems;
$('.Recently-Viewed-sec .collection ul.grid').css("width",rectotwid + "px");
$('.Recently-Viewed-sec .collection ul.grid li.grid__item').css("width",recnumItemw + "px");
//$('.Recently-Viewed-sec .collection ul.grid li.grid__item .card-wrapper').css("width",recnumItemw + "px");
}, 1000);
 }
}

function foottog(){
$(document).on("click",".footer-block__heading",function() {
$(this).next().toggleClass("is-opened").slideToggle();
$(this).next().toggleClass("is-select");
});
}

$(document).ready(function(){
foottog();
collecslid();
expcollecslid();
reccollecslid();
//========= Document Ready End=================
});







